"use client";
import Picture1 from "../images/top-recommended/burj-khalifa.jpg";
import Picture2 from "../images/top-recommended/palm-jumeirah.jpg";
import Picture3 from "../images/top-recommended/museum-of-the-future.jpg";
import Picture4 from "../images/top-recommended/desert-safari.jpg";
import Picture5 from "../images/top-recommended/dubai-aquarium.jpg";
import Picture6 from "../images/top-recommended/underwater-zoo.jpg";
import Picture7 from "../images/top-recommended/dubai-fountain.jpg";
import Picture8 from "../images/top-recommended/burj-ai-arab.jpg";
import Picture9 from "../images/top-recommended/dubai-marina.jpg";
import Picture10 from "../images/top-recommended/dubai-dolphinarium.jpg";
import Picture11 from "../images/top-recommended/dubai-frame.jpg";
import Picture12 from "../images/top-recommended/dubai-miracle-garden.jpg";
import Picture13 from "../images/top-recommended/ski-dubai.jpg";
import Picture14 from "../images/top-recommended/dubai-garden-glow.jpg";
import Picture15 from "../images/top-recommended/the-lost-chambers-aquarium.jpg";
import Picture16 from "../images/top-recommended/view-at-the-palm.jpg";
import Picture17 from "../images/top-recommended/ferrari-world.jpg";
import Picture18 from "../images/top-recommended/wild-wadi-water-park.jpg";
import Picture19 from "../images/top-recommended/jumeirah-beach.jpg";
import Picture20 from "../images/top-recommended/flyer.jpg";
import Picture21 from "../images/top-recommended/yas-island.jpg";
import Picture22 from "../images/top-recommended/laguna-water-park.jpg";
import Picture23 from "../images/top-recommended/aquaventure-waterpark.jpg";
import Picture24 from "../images/top-recommended/museum-of-illusions.jpg";
import Picture25 from "../images/top-recommended/mall-of-the-emirates.jpg";
import Picture26 from "../images/top-recommended/the-aura-skypool.jpg";
import Picture27 from "../images/top-recommended/world-island.jpg";
import Picture28 from "../images/top-recommended/sky-views-dubai.jpg";




import PaginationLeft from "@/public/svg/paginarition-arrow-left.svg";
import PaginationRight from "@/public/svg/paginarition-arrow-right.svg";

import Heading from "@/components/heading/heading";

import Image from "next/image";

import "@/styles/common/typo.scss";
import "@/sections/common/top-recommended/top-recommended.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";

const TopRecommendedList = [
    {
        name: "Burj Khalifa",
        picture: Picture1,
        location: "",
    },
    {
        name: "Palm Jumeirah",
        picture: Picture2,
        location: "",
    },
    {
        name: "Museum of the Future",
        picture: Picture3,
        location: "",
    },
    {
        name: "Desert Safari",
        picture: Picture4,
        location: "",
    },
    {
        name: "Dubai Aquarium",
        picture: Picture5,
        location: "",
    },
    {
        name: "Underwater Zoo",
        picture: Picture6,
        location: "",
    },
    {
        name: "Dubai Fountain",
        picture: Picture7,
        location: "",
    },
    {
        name: "Burj Al Arab",
        picture: Picture8,
        location: "",
    },
    {
        name: "Dubai Marina",
        picture: Picture9,
        location: "",
    },
    {
        name: "Dubai Dolphinarium",
        picture: Picture10,
        location: "",
    },
    {
        name: "Dubai Frame",
        picture: Picture11,
        location: "",
    },
    {
        name: "Dubai Miracle Garden",
        picture: Picture12,
        location: "",
    },
    {
        name: "Ski Dubai",
        picture: Picture13,
        location: "",
    },
    {
        name: "Dubai Garden Glow",
        picture: Picture14,
        location: "",
    },
    {
        name: "The Lost Chambers Aquarium",
        picture: Picture15,
        location: "",
    },
    {
        name: "View at the Palm",
        picture: Picture16,
        location: "",
    },
    {
        name: "Ferrari World",
        picture: Picture17,
        location: "",
    },
    {
        name: "Wild Wadi Water Park",
        picture: Picture18,
        location: "",
    },
    {
        name: "Jumeirah Beach",
        picture: Picture19,
        location: "",
    },
    {
        name: "iFly Dubai",
        picture: Picture20,
        location: "",
    },
    {
        name: "Yas Island",
        picture: Picture21,
        location: "",
    },
    {
        name: "Laguna Water Park",
        picture: Picture22,
        location: "",
    },
    {
        name: "Aquaventure Waterpark",
        picture: Picture23,
        location: "",
    },
    {
        name: "Museum of Illusions",
        picture: Picture24,
        location: "",
    },
    {
        name: "Mall of the Emirates",
        picture: Picture25,
        location: "",
    },
    {
        name: "The Aura Skypool",
        picture: Picture26,
        location: "",
    },
    {
        name: "World Island",
        picture: Picture27,
        location: "",
    },
    {
        name: "Sky Views Dubai",
        picture: Picture28,
        location: "",
    },

];

const TopRecommended = () => {
    return (
        <section className="top-recommended-section flex items-center py-10 md:py-20 gap-6">
            <div className="top-recommended-info flex flex-col gap-4 container-start">
                <div className="form-title flex flex-col">
                    <Heading as="h3" className="font-yesteryear font-extralight">
                        Top Recommended
                    </Heading>
                    <Heading as="h2" className="text-white">
                        Must Do Things
                    </Heading>
                </div>
                <p className="lead">
                Discover rich cultures, indulge in local cuisines, and explore breathtaking landscapes.
                </p>
                <div className="swiper-pagination-wrapper flex items-center gap-2 mt-2">
                    <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                        <figure className="pagination-left-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationLeft}
                                alt="Pagination Left"
                                
                            />
                        </figure>
                        <figure className="pagination-right-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationRight}
                                alt="Pagination Right"
                                
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="top-recommended-slider pl-4">
                <Swiper
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".pagination-right-top-recommended",
                        prevEl: ".pagination-left-top-recommended",
                        enabled: true,
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        480: {
                            slidesPerView: 2,
                        },
                        767: {
                            slidesPerView: 3,
                        },
                        1023: {
                            slidesPerView: 2,
                        },
                        1279: {
                            slidesPerView: 3,
                        },
                        1535: {
                            slidesPerView: 4,
                        },
                    }}
                    className="top-recommended-swiper"
                >
                    {TopRecommendedList.map((t, index) => {
                        return (
                            <SwiperSlide
                                key={index}
                                className="top-recommended-slide"
                            >
                                <a
                                   
                                    className="inline-flex flex-col gap-6"
                                >
                                    <figure>
                                        <Image loading="lazy"
                                            src={t.picture}
                                            alt={t.name}
                                            
                                        />
                                        <figcaption className="flex flex-col items-start justify-end p-4">
                                            <Heading
                                                as="h6"
                                                className="text-white"
                                            >
                                                {t.name}
                                            </Heading>
                                            <span className="font-light text-white">
                                                {t.location}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </a>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
};

export default TopRecommended;
